import { Badge } from '@mantine/core';

import { IconExternalLink } from '@tabler/icons-react';

import type { TestContentWithSimpleSteps } from '~/server/api/routers/test';
import { useProjectId } from '~/hooks/context/useProjectId';
import Link from 'next/link';
import { TestTypeIcon } from '~/components/test/TestTypeIcon';
import TimeAgo from '~/components/time/TimeAgo';
import CreatedBy from '~/components/test/CreatedBy';

export function CopyStepTestInfo({
  testContent,
  copyIntoTestContentId,
  updatedByUserEmail,
}: {
  testContent: TestContentWithSimpleSteps;
  copyIntoTestContentId: string;
  updatedByUserEmail?: string;
}) {
  const projectId = useProjectId();

  return (
    <div>
      <div className="flex items-start justify-between gap-4">
        <div className="flex min-w-0 flex-1 items-center gap-2">
          <div className="text-md max-w-[200px] truncate font-semibold md:max-w-sm lg:max-w-xl xl:max-w-2xl 2xl:max-w-4xl">
            {testContent.test.name}
          </div>
          <Link
            href={
              !testContent.trunkTest ?
                `/project/${projectId}/testDraft/${testContent.id}`
              : `/project/${projectId}/test/${testContent.test.id}`
            }
            target="_blank"
            className="flex-shrink-0 text-gray-500 hover:text-gray-700"
            onClick={(e) => e.stopPropagation()}
            aria-label={`Open ${testContent.test.name} in new tab`}
          >
            <IconExternalLink
              className="size-4"
              aria-hidden="true"
            />
          </Link>
        </div>
        <div className="flex flex-shrink-0 items-center gap-2 text-xs text-gray-600 dark:text-gray-400">
          <TimeAgo
            time={testContent.updatedAt}
            textStyle="text-stone-600 dark:text-stone-400"
          />
          {!!updatedByUserEmail && (
            <>
              <span>by</span>
              <CreatedBy email={updatedByUserEmail} />
            </>
          )}
        </div>
      </div>
      <div className="mt-1 flex gap-2">
        {testContent.id === copyIntoTestContentId && (
          <Badge
            color="blue"
            variant="dot"
          >
            current
          </Badge>
        )}
        <Badge
          color="gray"
          variant="light"
        >
          <TestTypeIcon
            type={testContent.test.testType}
            iconSize={14}
            className="text-[var(--mantine-badge-color)] dark:text-[var(--mantine-badge-color)]"
            showText
          />
        </Badge>
        {!testContent.trunkTest && (
          <Badge
            color="gray"
            variant="light"
          >
            Draft
          </Badge>
        )}
      </div>
    </div>
  );
}
